<template>
  <div class="px-4">
    <header class="fixed-top page-header">
    <div class="container-fluid container-fluid-max bg-black">
      <nav id="navbar" class="navbar navbar-expand-lg navbar-dark">
        <a class="navbar-brand" href="javascript:void(0)"><img src="static/images/logo_white.png" alt=""></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-lg-between" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <!-- <a class="nav-link" href="#process">Menu</a> -->
            </li>
          </ul>
          <div class="text-white" v-if="userName">
            <a href="javascript:void(0)" class="mr-2 h6">
              <i class="fas fa-user"></i>
              <div class="d-none d-xl-inline">{{userName}}</div>
            </a>
            <a class="h5" href="javascript:void(0)" @click="confirmLogout()" data-toggle="tooltip" data-placement="bottom" title="Logout">
              <i class="fa fa-power-off"></i>
            </a>
          </div>
          <div class="text-white" v-else>
            <a class="h5" href="javascript:void(0)" @click="login()" title="Login">
              Login
            </a>
          </div>
        </div>
      </nav>
    </div>
  </header>

  <main>
    <!-- <section id="home" class="d-flex align-items-center position-relative vh-100 cover hero" style="background-image:url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/162656/cappadocia.jpg);">
      <div class="container-fluid container-fluid-max">
        <div class="row">
          <div class="col-12 col-md-8 col-lg-6 col-xl-5">
            <h1 class="text-white">Live an unforgettable experience in Cappadocia!</h1>
            <div class="mt-3">
              <a class="btn bg-red text-white mr-2" href="" role="button">Book Now</a>
              <a class="btn bg-red text-white" href="" role="button">Select Your Package</a>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section id="process" class="process">
      <div class="container-fluid container-fluid-max">
        <div class="row text-center py-5">
          <div class="col-12 pb-4 pt-5">
            <h2 class="text-red">Welcome to CK One App</h2>
          </div>
          <div class="col-12 col-sm-6 col-lg-3" @click="mobileapps()">
            <span class="fa-stack fa-2x">
              <i class="fas fa-circle fa-stack-2x text-red"></i>
              <i class="fas fa-mobile fa-stack-1x text-white"></i>
            </span>
            <h3 class="mt-3 text-red h4">Download Mobile Apps</h3>
            <p>Download Charles &amp; Keith Mobile Applications<br>for IOS and Android Phones</p>
          </div>
<!--          <div class="col-12 col-sm-6 col-lg-3" @click="storerequest()">
            <span class="fa-stack fa-2x">
              <i class="fas fa-circle fa-stack-2x text-red"></i>
              <i class="fas fa-shopping-bag fa-stack-1x text-white"></i>
            </span>
            <h3 class="mt-3 text-red h4">Store Request</h3>
            <p>Request quantity from the store</p>
          </div>-->
<!--          <div class="col-12 col-sm-6 col-lg-3" @click="users()">-->
          <div v-if="hasPermission('View Users')" class="col-12 col-sm-6 col-lg-3" @click="users()">
            <span class="fa-stack fa-2x">
              <i class="fas fa-circle fa-stack-2x text-red"></i>
              <i class="fas fa-user fa-stack-1x text-white"></i>
            </span>
            <h3 class="mt-3 text-red h4">User Management</h3>
            <p>Creating and controlling user accounts.</p>
          </div>
          <!-- <div class="col-12 col-sm-6 col-lg-3">
            <span class="fa-stack fa-2x">
              <i class="fas fa-circle fa-stack-2x text-red"></i>
              <i class="fas fa-plane fa-stack-1x text-white"></i>
            </span>
            <h3 class="mt-3 text-red h4">Book a flight</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed repudiandae.</p>
          </div> -->
        </div>
      </div>
    </section>
  </main>
  <footer class="page-footer fixed-bottom">
    <nav class="navbar navbar-default  navbar-fixed-bottom" role="navigation">
      <div class="container text-center">
          <p class="navbar-text col-md-12 col-sm-12 col-xs-12">Charles &amp; Keith &copy; 2023 All Rights Reserved</p>
      </div>
  </nav>
  </footer>



  </div>
</template>

<script>
  import { bus } from './../../main.js'
  // import { compName } from './../../.env.js'

  // import MainHeader from '../layout/MainHeader.vue'
  // import MainSidebar from '../layout/MainSidebar.vue'
  // import XStore from './XStore.vue'

  export default {
    name: 'home',
    components: {
      // MainHeader,
      // MainSideb/\ar,
      // XStore
    },
    data() {
      return {
        userName: localStorage.getItem('username')?localStorage.getItem('username'):""
      }
    },
    mounted() {
      if (this.userName) {
        this.$store.dispatch('userPermissions', "User Management");
      }
      // this.$store.dispatch('userPermissions', "User Management")
      //   .then(permissions => {
      //     // permissions is the resolved data from the API call
      //     console.log('User permissions:', permissions);
      //   })
      //   .catch(error => {
      //     console.error('Failed to load permissions:', error);
      //   });
    },
    methods: {
      confirmLogout(){
        let vm = this;
        Swal.fire({
          title: 'Are you sure you want to logout?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then( function(result){
          if (result.value) {
            vm.$auth.destroyToken();
            // vm.$router.push('/');
            location.reload();
          }
        });
      },
      login(){
        this.$router.push('/login');
      },
      mobileapps(){
        this.$store.commit('saveModule', '/mobileapps');
        this.$router.push('/mobileapps');
        location.reload();
      },
      storerequest(){
        this.$store.commit('saveModule', '/storerequest');
        this.$router.push('/storerequest');
        location.reload();
      },
      users(){
          this.$store.commit('saveModule', '/users');
          this.$router.push('/users');
          location.reload();
        },

    },
    computed: {
      hasPermission() {
        return (name) => {
          const perms = this.$store.getters.userPermissions || []
          if (perms.length === 0) return false
          if (typeof perms[0] === 'string') {
            return perms.includes(name)
          }
          return false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/Index.vue